"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateSearchListResponseSchema = exports.CandidateSearchListResultSchema = exports.CandidateSearchResultItemSchema = void 0;
/* eslint-disable perfectionist/sort-objects */
const zod_1 = require("zod");
const schemas_1 = require("../../../schemas");
exports.CandidateSearchResultItemSchema = schemas_1.CandidateSchema.pick({
    id: true,
    dateOfBirth: true,
    employmentStatus: true,
    hideCompanyName: true,
    jobChangeCount: true,
    userNo: true,
}).extend({
    lastLoginAt: schemas_1.ISODateTimeSchema,
    location: schemas_1.LocationBaseSchema.nullable(),
    recentHistory: schemas_1.CandidateWorkHistorySchema.pick({
        id: true,
        companyName: true,
        jobDetail: true,
        startDate: true,
        endDate: true,
        isCurrent: true,
        minSalary: true,
        maxSalary: true,
        occupationId: true,
        industryId: true,
    }).extend({
        occupation: schemas_1.LocalizedFieldSchema,
        industry: schemas_1.LocalizedFieldSchema,
    }).nullable(),
});
exports.CandidateSearchListResultSchema = zod_1.z
    .object({ candidates: exports.CandidateSearchResultItemSchema.array() })
    .extend(schemas_1.PaginationResponseSchema.shape);
exports.CandidateSearchListResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.CandidateSearchListResultSchema);
